/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from "react";

const CustomPieTooltip = ({ active, payload, totalCaregivers }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    const percentage =
      totalCaregivers > 0
        ? Math.round((data.value / totalCaregivers) * 100)
        : 0;

    return (
      <div className="bg-white dark:bg-gray-800 p-3 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700">
        <div className="flex items-center gap-2 mb-2">
          <div
            className="w-3 h-3 rounded-full"
            style={{ backgroundColor: data.color }}
          ></div>
          <p className="font-bold text-text dark:text-dark-text text-sm">
            {data.name}
          </p>
        </div>
        <p className="text-sm text-gray-600 dark:text-gray-300">
          {data.value} caregivers
        </p>
        <p className="text-sm font-medium text-text dark:text-dark-text">
          {percentage}% of total
        </p>
      </div>
    );
  }
  return null;
};

export default CustomPieTooltip;
